import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner } from "react-bootstrap";
import moment from 'moment';
import DateBlock from '../home/DateBlock';
import "./_studentDiaryHome.scss"
import SelectDropDown from '../selectdropdown/SelectDropDown'
import { components } from 'react-select'
import MultiSelect from "react-multi-select-component";
import DiaryModal from './DiaryModal';
import NoticeModal from './NoticeModal';
import DiaryResponseModal from './DiaryResponseModal';
import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import DiaryTableRowDeleteModal from './DiaryTableRowDeleteModal';
import * as compose from "lodash.flowright";
import PdfViewModal from './pdfModal';



const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

const DELETE_DIARY_ROW_DATA = gql`
   mutation($dairyAssignmentId:ID){
    deleteDairyAssignmentData(dairyAssignmentId:$dairyAssignmentId)
   }
 `;

const EDIT_NOTICE_DIARY_DATA = gql`
mutation($params:AddDairyAssignmentDetails){
    addDairyAssignmentDetails(params:$params)
}
`;

class StundentDiaryHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch: "",
            branchSearch: "0",
            branchSearchval: "",
            getExamArr: [],
            examMultiError: "",
            examSelectedvalue: [],
            getClassArr: [],
            classMultiError: "",
            classSelectedvalue: [],
            getSectionArr: [],
            sectionMultiError: "",
            sectionSelectedvalue: [],
            selectedOptionId: "1",
            loader: 0,
            submitted: false,
            DiaryTableRowDeleteModal: false,
            viewDiaryMOdal: false,
            viewNoticeModal: false,
            loadingSpinner: 0,
            DiaryResponseModal: false,
            PdfViewModal: false,
            deleteId: "",
            spinnerStatus: "",
            noDateError: "",
            studentDairyNoticeCreationDetails: [],
            studentDairyNoticeSubmissionDetails: [],
            studentDiaryNoticeViewStatus: [],
            existingDairyOrNoticeData: [],
            pdfData: [],
            startDateCalender: moment(new Date()).subtract(1, "month").startOf('day').unix(),
            endDateCalender: moment(new Date()).startOf('day').unix(),
        }
    }

    componentDidMount() {
        let branchData = this.props.globals.globalBranches;
        let getExamArr = [];
        let getClassArr = [];
        let getSectionArr = [];

        if (branchData.length > 0) {
            // Exams selection
            let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id).map((item1) => item1.exam_id))].sort();

            uniqueExams.map((val) => {
                let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                const newObj = {
                    value: individualExamData.id,
                    label: individualExamData.exam
                }
                getExamArr.push(newObj);
            });

            //Class selection

            let selectedExamsValues = getExamArr.map((item) => item.value);

            let uniqueClasses = [];

            if (selectedExamsValues.length > 0) {

                selectedExamsValues.map((val) => {
                    let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
                    uniqueClasses.push(...individualClassValues)
                });
            }

            if (uniqueClasses.length > 0) {
                [...new Set(uniqueClasses)].map((val) => {
                    let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualClassData.id,
                        label: individualClassData.class
                    }
                    getClassArr.push(newObj);
                });

                let selectedClasses = getClassArr.map((item) => item.value);


                //section selection

                let uniqueSections = [];

                if (selectedClasses.length > 0) {
                    selectedExamsValues.map((val) => {
                        selectedClasses.map((val1) => {
                            let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                            if (individualsectionValues.length > 0) {
                                uniqueSections.push(...individualsectionValues)
                            }
                        })
                    });
                }

                if (uniqueSections.length > 0) {
                    [...new Set(uniqueSections)].map((val) => {
                        let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualSectionData.id,
                            label: individualSectionData.section_name
                        }
                        getSectionArr.push(newObj);
                    });
                }
            }
            this.setState({
                branchSearchval: {
                    value: branchData[0].id,
                    label: branchData[0].branch_name
                },
                branch: branchData[0].branch_name,
                branchSearch: branchData[0].id,
                branch_id: branchData[0].id,
                getExamArr: getExamArr,
                examSelectedvalue: getExamArr,
                getClassArr: getClassArr,
                classSelectedvalue: getClassArr,
                getSectionArr: getSectionArr,
                sectionSelectedvalue: getSectionArr,
                // studentsOptions: studentsArray,
                studentDairyNoticeCreationDetails: [],
                studentDairyNoticeSubmissionDetails: [],
                studentDiaryNoticeViewStatus: [],
                examMultiError: "",
                classMultiError: "",
                sectionMultiError: "",
            });
        }

        // BY DEFAULT ALL SELETED DATA TO WRITE BELOW CONDITION

        let e = {
            preventDefault: function () {

            }
        }

        setTimeout(() => {
            this.getDisplayMultiSelectData(e)

        }, 100)
        // ================================================
    }

    handleMultipleSelectInputChange = (e, name) => {

        console.log("multipleChange", e, name);


        if (name == "class") {

            let classSelectedvalue = [];
            let getSectionArr = [];

            if (e.length > 0) {
                for (let i = 0; i < e.length; i++) {
                    const classval = e[i];
                    const newObj = {
                        label: classval.label,
                        value: classval.value,
                    }
                    classSelectedvalue.push(newObj);
                }

                let selectedExamsValues = this.state.examSelectedvalue.map((item) => item.value);
                let selectedClasses = classSelectedvalue.map((item) => item.value);
                let uniqueSections = [];

                if (selectedClasses.length > 0) {
                    selectedExamsValues.map((val) => {
                        selectedClasses.map((val1) => {
                            let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                            if (individualsectionValues.length > 0) {
                                uniqueSections.push(...individualsectionValues)
                            }
                        })
                    });
                }

                if (uniqueSections.length > 0) {
                    [...new Set(uniqueSections)].map((val) => {
                        let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualSectionData.id,
                            label: individualSectionData.section_name
                        }
                        getSectionArr.push(newObj);
                    });
                }


                this.setState({
                    classSelectedvalue: classSelectedvalue,

                    examMultiError: "",
                    classMultiError: "",
                    sectionMultiError: "",
                    getSectionArr: getSectionArr,
                    sectionSelectedvalue: getSectionArr,
                });
            } else {
                this.setState({
                    classSelectedvalue: classSelectedvalue,

                    examMultiError: "",
                    classMultiError: "",
                    sectionMultiError: "",
                    getSectionArr: [],
                    sectionSelectedvalue: [],
                });
            }
        }

        if (name == "exam") {
            let examSelectedvalue = [];

            if (e.length > 0) {

                for (let i = 0; i < e.length; i++) {
                    const examval = e[i];
                    const newObj = {
                        label: examval.label,
                        value: examval.value,
                    }
                    examSelectedvalue.push(newObj);
                }


                let selectedExamsValues = examSelectedvalue.map((item) => item.value);

                let uniqueClasses = [];
                let getClassArr = [];
                let getSectionArr = [];


                if (selectedExamsValues.length > 0) {

                    selectedExamsValues.map((val) => {
                        let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
                        console.log("individualClassValues", individualClassValues);
                        uniqueClasses.push(...individualClassValues)
                    });
                }



                if (uniqueClasses.length > 0) {
                    [...new Set(uniqueClasses)].map((val) => {

                        console.log("uniqueClasses", val);

                        let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualClassData.id,
                            label: individualClassData.class
                        }
                        getClassArr.push(newObj);
                    });

                    let selectedClasses = getClassArr.map((item) => item.value);


                    //section selection

                    let uniqueSections = [];

                    if (selectedClasses.length > 0) {
                        selectedExamsValues.map((val) => {
                            selectedClasses.map((val1) => {
                                let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                                if (individualsectionValues.length > 0) {
                                    uniqueSections.push(...individualsectionValues)
                                }
                            })
                        });
                    }

                    if (uniqueSections.length > 0) {
                        [...new Set(uniqueSections)].map((val) => {
                            let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                            const newObj = {
                                value: individualSectionData.id,
                                label: individualSectionData.section_name
                            }
                            getSectionArr.push(newObj);
                        });
                    }
                }

                this.setState({
                    examSelectedvalue: examSelectedvalue,
                    getClassArr: getClassArr,
                    classSelectedvalue: getClassArr,
                    getSectionArr: getSectionArr,
                    sectionSelectedvalue: getSectionArr,
                    examMultiError: "",
                    classMultiError: "",
                    sectionMultiError: "",
                });
            } else {
                this.setState({
                    examSelectedvalue: [],
                    getClassArr: [],
                    classSelectedvalue: [],
                    getSectionArr: [],
                    sectionSelectedvalue: [],
                    examMultiError: "",
                    classMultiError: "",
                    sectionMultiError: "",
                });
            }
        }

        if (name == "section") {

            let sectionSelectedvalue = [];

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const sectionval = e[i];
                    const newObj = {
                        label: sectionval.label,
                        value: sectionval.value,
                    }
                    sectionSelectedvalue.push(newObj);
                }
                this.setState({
                    sectionSelectedvalue: sectionSelectedvalue,
                    examMultiError: "",
                    classMultiError: "",
                    sectionMultiError: "",
                });
            }
        }
    }

    dropDownGetValues(fieldname) {
        let getArray = [];
        if (fieldname == "branchSearch") {
            let uniqueBranches = [...new Set(this.props.globals.b_e_c_s_data.map((item) => item.branch_id))];
            uniqueBranches.map((val) => {
                let individualBranchData = this.props.globals.globalBranches.find((item1) => item1.id == val);
                const newObj = {
                    value: individualBranchData.id,
                    label: individualBranchData.branch_name
                }
                getArray.push(newObj);
            });
        }
        return getArray;
    }

    selecthandleBranch = (name, value) => {

        if (name == "branchSearch") {
            if (value != "0") {
                let branchSearchData = this.props.globals.globalBranches.find((a) => a.id == value);
                console.log("branchSearchData", branchSearchData);

                let getExamArr = [];
                let getClassArr = [];
                let getSectionArr = [];

                if (branchSearchData != null) {
                    // Exams selection
                    let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchSearchData.id).map((item1) => item1.exam_id))].sort();

                    uniqueExams.map((val) => {
                        let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualExamData.id,
                            label: individualExamData.exam
                        }
                        getExamArr.push(newObj);
                    });
                    // ==================================================
                    this.setState({
                        studentDairyNoticeCreationDetails: []
                    })
                    // ============================================================
                    //Class selection

                    let selectedExamsValues = getExamArr.map((item) => item.value);

                    let uniqueClasses = [];

                    if (selectedExamsValues.length > 0) {

                        selectedExamsValues.map((val) => {
                            let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchSearchData.id && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
                            uniqueClasses.push(...individualClassValues)
                        });
                    }

                    if (uniqueClasses.length > 0) {
                        [...new Set(uniqueClasses)].map((val) => {
                            let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                            const newObj = {
                                value: individualClassData.id,
                                label: individualClassData.class
                            }
                            getClassArr.push(newObj);
                        });

                        let selectedClasses = getClassArr.map((item) => item.value);


                        //section selection

                        let uniqueSections = [];

                        if (selectedClasses.length > 0) {
                            selectedExamsValues.map((val) => {
                                selectedClasses.map((val1) => {
                                    let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchSearchData.id && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                                    if (individualsectionValues.length > 0) {
                                        uniqueSections.push(...individualsectionValues)
                                    }
                                })
                            });
                        }

                        if (uniqueSections.length > 0) {
                            [...new Set(uniqueSections)].map((val) => {
                                let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                                const newObj = {
                                    value: individualSectionData.id,
                                    label: individualSectionData.section_name
                                }
                                getSectionArr.push(newObj);
                            });
                        }
                    }

                    this.setState({
                        branchSearchval: {
                            value: branchSearchData.id,
                            label: branchSearchData.branch_name
                        },
                        branch: branchSearchData.branch_name,
                        branchError: "",
                        branch_id: branchSearchData.id,
                        getExamArr: getExamArr,
                        examSelectedvalue: getExamArr,
                        getClassArr: getClassArr,
                        classSelectedvalue: getClassArr,
                        getSectionArr: getSectionArr,
                        sectionSelectedvalue: getSectionArr,
                        noDateError: "",
                        examMultiError: "",
                        classMultiError: "",
                        sectionMultiError: "",
                    });
                }

            }
        }

        this.setState({ [name]: value });
    }

    getDisplayMultiSelectData = async (e) => {
        console.log("eeeeee", e);
        e.preventDefault();

        if (!this.state.examSelectedvalue.length) {
            this.setState({ examMultiError: "Please select exam" });
            return ""
        }

        if (!this.state.classSelectedvalue.length) {
            this.setState({ classMultiError: "Please select class" });
            return ""
        }

        if (!this.state.sectionSelectedvalue.length) {
            this.setState({ sectionMultiError: "Please select section" });
            return ""
        }
        this.setState({
            loader: 1
        })

        const result = await this.props.client.query({
            query: gql`
              query($institute_id:Int,$branch_id:Int,$dairy_assignment_type_id:Int,$from_date:String,$to_date:String){
                getStudentDairyAssignmentDetails(institute_id:$institute_id,branch_id:$branch_id,dairy_assignment_type_id:$dairy_assignment_type_id,from_date:$from_date,to_date:$to_date){

                    dairy_assignment_creation_details
                    {
                         dairyAssigment_id
                         title
                         description
                         file_path
                         assignment_marks
                         to_date
                         from_date
                         employee_id
                         exam_id
                         class_id
                         subject_id
                         section_ids
                         Class
                         Exam
                         Section_Name
                         subject_name
                      
                    }

                        dairy_assignment_submitted_details
                    {
                         dairyAssignmentStatus_id
                         dairy_assignment_id
                         edu_student_id
                         status
                         upload_file_path
                         comments
                         submitted_time
                         student_name
                         student_mobile
                         roll_no
                         parent_name
                         parent_mobile
                         class_id
                         exam_id
                         section_id
                         marks
                         verifier_comments
                    }
                    total_students_details
                    {
                         edu_student_id
                         student_name
                         student_mobile
                         roll_no
                         parent_name
                         parent_mobile
                         class_id
                         exam_id
                         section_id
                    }
                    }
                }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                // branch_id: this.state.selectedOptionId == "1" ? (parseInt(this.state.branch_id)) : (parseInt(this.state.branchSearch)),
                branch_id: parseInt(this.state.branchSearch),
                dairy_assignment_type_id: parseInt(this.state.selectedOptionId),
                // from_date: moment(this.state.formDate, 'YYYY-MM-DD').unix().toString(),
                from_date: this.state.startDateCalender.toString(),
                to_date: this.state.endDateCalender.toString(),
            },
            fetchPolicy: 'network-only'
        })
        console.log("result", result.from_date, result.to_date);

        if (result.data.getStudentDairyAssignmentDetails[0]?.dairy_assignment_creation_details.length > 0) {
            let data = result.data.getStudentDairyAssignmentDetails[0].dairy_assignment_creation_details;

            console.log("result", data);


            let filteredArray = [];

            if (this.state.selectedOptionId == "2" || this.state.selectedOptionId == "1") {
                const examFilter = this.state.examSelectedvalue.map(item => item.value);
                const classFilter = this.state.classSelectedvalue.map(item => item.value.toString());
                const sectionFilter = this.state.sectionSelectedvalue.map(item => item.value);

                filteredArray = data.filter(item => {
                    const itemExamId = item.exam_id.split(',');

                    const itemClassId = item.class_id.split(',');

                    const itemSectionIds = item.section_ids.split(',');

                    console.log("ddddd", itemExamId, itemClassId, itemSectionIds, classFilter, examFilter, sectionFilter, this.state.classSelectedvalue);

                    const examMatch = itemExamId.some(id => examFilter.includes(id));
                    const classMatch = itemClassId.some(id => classFilter.includes(id));;
                    const sectionMatch = itemSectionIds.some(id => sectionFilter.includes(id));

                    // const dateFilter = item.from_date.some(date => this.state.formDate.includes(date));
                    console.log("sssss", examMatch, classMatch, sectionMatch);

                    return examMatch &&
                        classMatch &&
                        sectionMatch;
                    // &&  dateFilter;
                });

            }
            else {
                filteredArray = data.filter((item) => item.exam_id == this.state.exam_id && item.class_id == this.state.class_id && item.section_ids == this.state.section_id)
            }

            console.log(filteredArray);

            console.log("filteredArray", filteredArray);
            this.setState({
                studentDairyNoticeCreationDetails: filteredArray,
                submitted: false,
                loader: 0
            })
        } else {
            this.setState({ loader: 0, noDateError: "No Data Available" })
        }

        if (result.data.getStudentDairyAssignmentDetails[0]?.dairy_assignment_submitted_details.length > 0) {
            let data1 = result.data.getStudentDairyAssignmentDetails[0].dairy_assignment_submitted_details;
            console.log("data2", data1);
            this.setState({
                studentDairyNoticeSubmissionDetails: data1,
            })
        }

        if (result.data.getStudentDairyAssignmentDetails[0]?.total_students_details.length > 0) {

            let data2 = result.data.getStudentDairyAssignmentDetails[0]?.total_students_details;

            this.setState({
                studentDiaryNoticeViewStatus: data2,
            })
        }

    }

    handleInputRadioChange = (e) => {
        const { name, value } = e.target;
        if (name == "radioOption") {
            const selectedOptionId = e.target.id;
            if (selectedOptionId != this.state.selectedOptionId) {
                this.setState({
                    selectedOptionId,
                    studentDairyNoticeCreationDetails: [],
                    noDateError: "",
                    examMultiError: "",
                    classMultiError: "",
                    sectionMultiError: "",
                });
                // BY DEFAULT ALL SELETED DATA TO WRITE BELOW CONDITION
                let e = {
                    preventDefault: function () {

                    }
                }
                setTimeout(() => {
                    this.getDisplayMultiSelectData(e)

                }, 1000)
                // =================================================================================
            }
        }
    };

    applyCallback = (startDate, endDate) => {
        this.setState({
            startDateCalender: startDate.startOf('day').unix(),
            endDateCalender: endDate.startOf('day').unix(),
            studentDiaryNoticeViewStatus: [],
            studentDairyNoticeSubmissionDetails: [],
            studentDairyNoticeCreationDetails: [],
            noDateError: "",

        })
    }

    handleDelete = async (i) => {
        this.setState({
            spinnerStatus: "1"
        });
        await this.props.deleteDairyAssignmentData({
            variables: {
                dairyAssignmentId: parseInt(this.state.deleteId)
            },
            update: (store, { data }) => {
                if (data.deleteDairyAssignmentData == true) {
                    this.setState({
                        loadingSpinner: 1,
                        currentStep: 5,
                        submitted: "Deleted Successfully...",
                        spinnerStatus: ""
                    });
                }
                window.location.reload(true)
            }
        });
    }


    render() {


        let selectOptions = "";
        if (this.state.selectedOptionId == "1") {
            selectOptions = <h5>DIARY</h5>
        } else if (this.state.selectedOptionId == "2") {
            selectOptions = <h5>NOTICE</h5>
        }


        console.log("selectOptions", selectOptions);

        let examselectall = true;
        let examlabelledBy = "Select";
        let examdisableSearch = false;

        let classselectall = true;
        let classlabelledBy = "Select";
        let classdisableSearch = false;

        let sectionselectall = true;
        let sectionlabelledBy = "Select";
        let sectiondisableSearch = false;

        if (this.props.globals.classes.length > 0) {
            classselectall = true;
            classdisableSearch = false;
        }
        else {
            classdisableSearch = true;
            classselectall = false;
            classlabelledBy = "Class"
        }


        if (this.props.globals.exams.length > 0) {
            examselectall = true;
            examdisableSearch = false;
        }
        else {
            examdisableSearch = true;
            examselectall = false;
            examlabelledBy = "Exam"
        }

        if (this.props.globals.globalSections.length > 0) {
            sectionselectall = true;
            sectiondisableSearch = false;
        }
        else {
            sectiondisableSearch = true;
            sectionselectall = false;
            sectionlabelledBy = "Section"
        }

        return (
            <>
                <Container>
                    <Row className="mt-2">
                        <Col xl={12} lg={12} md={12} sm={12}>
                            <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                                <h5 className="title  mb-0 text-uppercase d-flex">Student <span className='ml-1'>{selectOptions}</span></h5>
                                {/* STUDENT <span>{this.state.selectedOptionId === "1" ? <h5>DIARY</h5>: this.state.selectedOptionId === "2" ? <h5>NOTICE</h5> : ""}</span> */}
                            <div className='d-flex justify-content-end'>
                            <div className='d-flex justify-content-end my-2 mr-1'>
                                {
                                    this.state.selectedOptionId == "1" ? (

                                        <div>
                                            <button class="button_Diary text-uppercase" onClick={() => { this.setState({ viewDiaryMOdal: true, existingDairyOrNoticeData: [], noDateError: "" }) }}>Diary</button>
                                        </div>
                                    ) : (
                                        <div className='ml-2'>
                                            <button class="button_Notice text-uppercase" onClick={() => { this.setState({ viewNoticeModal: true, noDateError: "" }) }}>Notice</button>
                                        </div>
                                    )
                                }

                            </div>
                            </div>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={6}>
                            <div className='mt-4'>
                                <Form.Check type="radio" name="radioOption" id="1" label="Diary" className="mr-3  RadioButtons h6" onChange={this.handleInputRadioChange} checked={this.state.selectedOptionId == "1"} style={{ cursor: "pointer" }} />
                                <Form.Check type="radio" name="radioOption" id="2" label="Notice" className='RadioButtons2 h6' onChange={this.handleInputRadioChange} style={{ cursor: "pointer" }} />
                            </div>
                        </Col>
                        <Col sm={6}>
                            <div className='d-flex justify-content-end  mr-5'>
                                <Form.Group className="customDate mb-0 mr-5" controlId="StartDate" style={{ width: "110px" }}>
                                    <DateBlock applyCallback={this.applyCallback} start={this.start} end={this.end} data="dairyOrNotice" />
                                </Form.Group>
                            </div>
                        </Col>
                    </Row>

                    {
                        this.state.selectedOptionId == "1" ? (
                            <>
                                <Form className='mt-3'>

                                    <Form.Row>

                                        <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectBranch">
                                            <Form.Label className="text-uppercase font-weight-bold">Branch</Form.Label>
                                            <SelectDropDown
                                                stateData={this.state.branchSearchval}
                                                handleChange={this.selecthandleBranch}
                                                name="branchSearch"
                                                options={this.dropDownGetValues("branchSearch")}
                                                placeholderName={'Branch'}
                                                dropdownIndicator={{ DropdownIndicator }}
                                            />
                                        </Form.Group>

                                        <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectExam">
                                            <Form.Label className="text-uppercase font-weight-bold">Exam</Form.Label>
                                            <MultiSelect
                                                overrideStrings={{
                                                    "allItemsAreSelected": "All Exams are selected.",
                                                    "selectSomeItems": examlabelledBy
                                                }
                                                }
                                                disableSearch={examdisableSearch}
                                                hasSelectAll={examselectall}
                                                options={this.state.getExamArr}
                                                value={this.state.examSelectedvalue}
                                                onChange={(e) => this.handleMultipleSelectInputChange(e, "exam")}
                                                labelledBy={"exam"}
                                            />
                                            <Form.Text className="form-text text-danger h6">
                                                {this.state.examMultiError}
                                            </Form.Text>
                                        </Form.Group>

                                        <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                                            <Form.Label className="text-uppercase font-weight-bold">Class</Form.Label>
                                            <MultiSelect
                                                overrideStrings={{
                                                    "allItemsAreSelected": "All Classes are selected.",
                                                    "selectSomeItems": classlabelledBy
                                                }
                                                }
                                                disableSearch={classdisableSearch}
                                                hasSelectAll={classselectall}
                                                options={this.state.getClassArr}
                                                value={this.state.classSelectedvalue}
                                                onChange={(e) => this.handleMultipleSelectInputChange(e, "class")}
                                                labelledBy={"class"}
                                            />
                                            <Form.Text className="form-text text-danger h6">
                                                {this.state.classMultiError}
                                            </Form.Text>
                                        </Form.Group>

                                        <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectSection">
                                            <Form.Label className="text-uppercase font-weight-bold">Section</Form.Label>
                                            <MultiSelect
                                                overrideStrings={{
                                                    "allItemsAreSelected": "All Sections are selected.",
                                                    "selectSomeItems": sectionlabelledBy
                                                }
                                                }
                                                disableSearch={sectiondisableSearch}
                                                hasSelectAll={sectionselectall}
                                                options={this.state.getSectionArr}
                                                value={this.state.sectionSelectedvalue}
                                                onChange={(e) => this.handleMultipleSelectInputChange(e, "section")}
                                                labelledBy={"section"}
                                            />
                                            <Form.Text className="form-text text-danger h6">
                                                {this.state.sectionMultiError}
                                            </Form.Text>
                                        </Form.Group>

                                        <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectStudent">
                                            <button className='button_01 text-uppercase' onClick={this.getDisplayMultiSelectData}>Submit</button>
                                        </Form.Group>
                                    </Form.Row>
                                </Form>

                                <section className=''>
                                    {
                                        this.state.studentDairyNoticeCreationDetails.length > 0 ?

                                            (
                                                <><Table className="table table-bordered border-dark" border="1px">
                                                    <thead style={{ backgroundColor: "#213046", color: "#fff" }}>
                                                        <tr>
                                                            <th className="text-center">Date</th>
                                                            <th className="text-center">Exam</th>
                                                            <th className="text-center">Class</th>
                                                            <th className="text-center">Section</th>
                                                            <th className="text-center">Subject/Description</th>
                                                            <th className="text-center">Edit</th>
                                                            <th className="text-center">Status Details</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="">
                                                        {
                                                            this.state.examSelectedvalue.map((examValue) =>
                                                            (
                                                                this.state.classSelectedvalue.map((classValue) =>
                                                                (
                                                                    this.state.sectionSelectedvalue.map((sectionValue) => {
                                                                        const filteredData = this.state.studentDairyNoticeCreationDetails.filter((item) => (
                                                                            item.Exam == examValue.label && item.Class == classValue.label && item.Section_Name == sectionValue.label
                                                                        ));


                                                                        let uniqueDates = [...new Set(filteredData.map((date) => date.from_date))]

                                                                        let uniqueDateWiseRecord = [];

                                                                        if (uniqueDates.length > 0) {

                                                                            return (
                                                                                <>
                                                                                    {
                                                                                        uniqueDates.map((uniqueDate) => {
                                                                                            let data = filteredData.filter((dateWiseRecords) => dateWiseRecords.from_date == uniqueDate)

                                                                                            console.log("uniqueDates", data);

                                                                                            const date = (data && data.length > 0 && data[0].from_date)
                                                                                                ? moment.unix(data[0].from_date).format("DD-MM-YYYY") : ("")

                                                                                            return (
                                                                                                <React.Fragment key={`${examValue.label}-${classValue.label}-${sectionValue.label}`}>
                                                                                                    {data.map((item, index) => (
                                                                                                        <tr key={index}
                                                                                                            className={`${item.Exam === 'NEET' ? 'neet-row' : item.Exam === 'JEE' ? 'jee-row' : 'jee-row'}`}
                                                                                                        >
                                                                                                            {index == 0 ? (
                                                                                                                <>
                                                                                                                    <td rowSpan={data.length} className="align-middle date_text text-center">
                                                                                                                        {date}
                                                                                                                    </td>
                                                                                                                    <td rowSpan={data.length} className="align-middle text-center">
                                                                                                                        {item.Exam}
                                                                                                                    </td>
                                                                                                                    <td rowSpan={data.length} className="align-middle text-center">
                                                                                                                        {item.Class}
                                                                                                                    </td>
                                                                                                                    <td rowSpan={data.length} className="align-middle text-center">
                                                                                                                        {item.Section_Name}
                                                                                                                    </td>
                                                                                                                </>
                                                                                                            ) : null}
                                                                                                            {/* <td className='table-hover '><strong style={{ color: 'blue' }}>{item?.subject_name}:</strong> {item?.description}</td> */}

                                                                                                            <td>
                                                                                                                <div><span className='text-primary h6'>{item?.subject_name}  :</span>     <span className='mr-3'>{item?.description}</span></div>
                                                                                                            </td>

                                                                                                            <td>
                                                                                                                <div className="actions-buttons d-flex justify-content-center align-items-top text-center" onClick={() => { this.setState({ viewDiaryMOdal: true, existingDairyOrNoticeData: [item] }) }}>
                                                                                                                    <Button variant="link" name="view" className="text-theme">
                                                                                                                        <i className="fas fa-edit " style={{ color: 'black' }} />
                                                                                                                    </Button>
                                                                                                                </div>
                                                                                                            </td>
                                                                                                            {index == 0 ? (
                                                                                                                <td rowSpan={data.length} className="align-middle">
                                                                                                                    <div className="actions-buttons d-flex justify-content-center align-items-top text-center" onClick={() => { this.setState({ DiaryResponseModal: true, deleteId: item.dairyAssigment_id }) }}>
                                                                                                                        <Button variant="link" name="view" className="text-theme">
                                                                                                                            <i className="fas fa-eye " style={{ color: 'black' }} />
                                                                                                                        </Button>
                                                                                                                    </div>
                                                                                                                </td>
                                                                                                            ) : null}

                                                                                                        </tr>
                                                                                                    ))}
                                                                                                </React.Fragment>
                                                                                            );
                                                                                            uniqueDateWiseRecord.push(data)
                                                                                        })
                                                                                    }
                                                                                </>
                                                                            )
                                                                        }

                                                                        console.log("filteredData", uniqueDateWiseRecord);
                                                                    }
                                                                    )
                                                                )
                                                                )
                                                            )
                                                            )
                                                        }
                                                    </tbody>
                                                </Table>
                                                </>
                                            ) : (

                                                <Row>
                                                    {
                                                        <>
                                                            <Col sm={12}>
                                                                <div className={this.state.loader == 1 ? "d-flex align-items-center spinner-border text-primary text-center loading-img-center" : ""}></div>
                                                            </Col>
                                                            <Col sm={12}>
                                                                {
                                                                    this.state.noDateError != "" ?
                                                                        (
                                                                            <h6 className='d-flex justify-content-center align-content-center'>{this.state.noDateError}</h6>
                                                                        )
                                                                        :
                                                                        ("")
                                                                }
                                                            </Col>
                                                        </>
                                                    }
                                                </Row>
                                            )

                                    }
                                </section>
                            </>
                        ) : (
                            this.state.selectedOptionId == "2" ? (
                                <>
                                    <Form className='mt-3'>

                                        <Form.Row>

                                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectBranch">
                                                <Form.Label className="text-uppercase font-weight-bold">Branch</Form.Label>
                                                <SelectDropDown
                                                    stateData={this.state.branchSearchval}
                                                    handleChange={this.selecthandleBranch}
                                                    name="branchSearch"
                                                    options={this.dropDownGetValues("branchSearch")}
                                                    placeholderName={'Branch'}
                                                    dropdownIndicator={{ DropdownIndicator }}
                                                />
                                            </Form.Group>

                                            <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectExam">
                                                <Form.Label className="text-uppercase font-weight-bold">Exam</Form.Label>
                                                <MultiSelect
                                                    overrideStrings={{
                                                        "allItemsAreSelected": "All Exams are selected.",
                                                        "selectSomeItems": examlabelledBy
                                                    }
                                                    }
                                                    disableSearch={examdisableSearch}
                                                    hasSelectAll={examselectall}
                                                    options={this.state.getExamArr}
                                                    value={this.state.examSelectedvalue}
                                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "exam")}
                                                    labelledBy={"exam"}
                                                />
                                                <Form.Text className="form-text text-danger h6">
                                                    {this.state.examMultiError}
                                                </Form.Text>
                                            </Form.Group>

                                            <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                                                <Form.Label className="text-uppercase font-weight-bold">Class</Form.Label>
                                                <MultiSelect
                                                    overrideStrings={{
                                                        "allItemsAreSelected": "All Classes are selected.",
                                                        "selectSomeItems": classlabelledBy
                                                    }
                                                    }
                                                    disableSearch={classdisableSearch}
                                                    hasSelectAll={classselectall}
                                                    options={this.state.getClassArr}
                                                    value={this.state.classSelectedvalue || []}
                                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "class")}
                                                    labelledBy={"class"}
                                                />
                                                <Form.Text className="form-text text-danger h6">
                                                    {this.state.classMultiError}
                                                </Form.Text>
                                            </Form.Group>

                                            <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectSection">
                                                <Form.Label className="text-uppercase font-weight-bold">Section</Form.Label>
                                                <MultiSelect
                                                    overrideStrings={{
                                                        "allItemsAreSelected": "All Sections are selected.",
                                                        "selectSomeItems": sectionlabelledBy
                                                    }
                                                    }
                                                    disableSearch={sectiondisableSearch}
                                                    hasSelectAll={sectionselectall}
                                                    options={this.state.getSectionArr}
                                                    value={this.state.sectionSelectedvalue || []}
                                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "section")}
                                                    labelledBy={"section"}
                                                />
                                                <Form.Text className="form-text text-danger h6">
                                                    {this.state.sectionMultiError}
                                                </Form.Text>
                                            </Form.Group>

                                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectStudent">
                                                <button className='button_01 text-uppercase' onClick={this.getDisplayMultiSelectData}>Submit</button>
                                            </Form.Group>

                                        </Form.Row>
                                    </Form>

                                    <section className='mt-2'>
                                        {
                                            this.state.studentDairyNoticeCreationDetails.length > 0 ?
                                                (
                                                    <>
                                                        <Row>
                                                            <Col as={Col} lg={8} md={12} sm={12}>
                                                                {/* <h6><span className="text-danger">*  </span>  Here are the details of the student Notice</h6> */}
                                                            </Col>
                                                            <Col as={Col} lg={4} md={12} sm={12}>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col xl={12} lg={12} md={12}>
                                                                <Table className="table table-bordered table-custom" cellSpacing="0">
                                                                    <thead style={{ backgroundColor: "#213046", color: "#fff" }}>
                                                                        <tr className="text-center">
                                                                            <th>Sno</th>
                                                                            <th>Date</th>
                                                                            <th>Description</th>
                                                                            <th>Notice</th>
                                                                            <th>Status Details</th>
                                                                            <th>Delete</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className="text-center">
                                                                        {
                                                                            this.state.studentDairyNoticeCreationDetails.map((item, index) => {
                                                                                let sno = index + 1;
                                                                                let date = moment.unix(item.from_date).format("DD-MM-YYYY");
                                                                                return (
                                                                                    <>
                                                                                        <tr key={index} className='table_body'>
                                                                                            <td className="align-middle">{sno}</td>
                                                                                            <td className='date_text align-middle'>{date}</td>
                                                                                            <td className="align-middle">{item?.description}</td>

                                                                                            <td className='align-middle text-center align-middle'>
                                                                                                <div style={{ cursor: "pointer"}} className='h6'>
                                                                                                    {item.file_path != null && item.file_path != "" ? (
                                                                                                        <div  onClick={() => { this.setState({ PdfViewModal: true, pdfData: [item] }) }} style={{textDecoration:"underline"}}>View Notice</div>
                                                                                                    ) : (
                                                                                                        <div>-</div>
                                                                                                    )}
                                                                                                </div>

                                                                                            </td>

                                                                                            <td>
                                                                                                <h6>
                                                                                                    <div className="actions-buttons d-flex justify-content-center align-items-top align-middle" onClick={() => { this.setState({ DiaryResponseModal: true, deleteId: item.dairyAssigment_id }) }}>
                                                                                                        <Button variant="link" name="view" className="text-theme">
                                                                                                            <i className="fas fa-eye " />
                                                                                                        </Button>
                                                                                                    </div>
                                                                                                </h6>

                                                                                            </td>
                                                                                            <td>
                                                                                                <div className="actions-buttons d-flex justify-content-center align-items-top align-middle">
                                                                                                    <Button variant="link" name="delete" className="text-danger">
                                                                                                        <i className="far fa-trash-alt" onClick={() => { this.setState({ DiaryTableRowDeleteModal: true, deleteId: item.dairyAssigment_id }) }} />
                                                                                                    </Button>
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </>
                                                                                )
                                                                            })
                                                                        }

                                                                    </tbody>
                                                                </Table>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                ) : (
                                                    <Row>
                                                        <Col sm={12}>
                                                            <div className={this.state.loader == 1 ? "d-flex align-items-center spinner-border text-primary text-center loading-img-center" : ""}></div>
                                                        </Col>
                                                        <Col sm={12}>
                                                            {
                                                                this.state.noDateError != "" ?
                                                                    (
                                                                        <h6 className='d-flex justify-content-center align-content-center'>{this.state.noDateError}</h6>
                                                                    )
                                                                    :
                                                                    ("")
                                                            }
                                                        </Col>
                                                    </Row>
                                                )
                                        }
                                    </section>

                                </>
                            ) : ""
                        )
                    }
                    <DiaryModal
                        stateData={this.state}
                        show={this.state.viewDiaryMOdal}
                        onHide={() => this.setState({ viewDiaryMOdal: false })}
                        globals={this.props.globals}
                    />

                    <NoticeModal
                        stateData={this.state}
                        show={this.state.viewNoticeModal}
                        onHide={() => this.setState({ viewNoticeModal: false })}
                        globals={this.props.globals}
                        getStudents={this.props.getStudents}
                    />

                    <DiaryResponseModal
                        stateData={this.state}
                        show={this.state.DiaryResponseModal}
                        onHide={() => this.setState({ DiaryResponseModal: false })}
                        globals={this.props.globals}

                    />

                    <PdfViewModal
                        stateData={this.state}
                        show={this.state.PdfViewModal}
                        onHide={() => this.setState({ PdfViewModal: false })}
                        globals={this.props.globals}
                    />

                    <DiaryTableRowDeleteModal
                        stateData={this.state}
                        show={this.state.DiaryTableRowDeleteModal}
                        onHide={() => this.setState({ DiaryTableRowDeleteModal: false })}
                        globals={this.props.globals}
                        handleDelete={this.handleDelete}
                    />
                </Container>
            </>
        )
    }
}
export default withRouter(withApollo(compose(
    graphql(DELETE_DIARY_ROW_DATA, {
        name: "deleteDairyAssignmentData"
    }),
    graphql(EDIT_NOTICE_DIARY_DATA, {
        name: "addDairyAssignmentDetails"
    })
)(StundentDiaryHome)));